// these are temporary types for now

import { ComponentKey } from "@certa/studio-core";

export type Field = {
  name: string;
  body: string;
  fieldType: string;
  isRequired: boolean;
};

export type Step = {
  name: string;
  tag: string;
};

export type Stepgroup = {
  name: string;
  tag: string;
  staticGroups: string[];
};

export enum NodeTypes {
  STEPGROUP = "stepgroupNode",
  STEP = "stepNode",
  FIELD = "fieldNode",
  ADDNEW = "addNewNode",
  DEPENDENCY = "dependency"
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const NodeTypeToComponentKey = {
  [NodeTypes.STEPGROUP]: ComponentKey.SWIMLANES,
  [NodeTypes.STEP]: ComponentKey.STEPS,
  [NodeTypes.FIELD]: ComponentKey.FIELDS,
  [NodeTypes.ADDNEW]: undefined,
  [NodeTypes.DEPENDENCY]: undefined
} as const;

export enum EdgeTypes {
  FLOW = "custom-flow",
  DEPENDENCY = "dependency",
  SMART_DEPENDENCY = "smart-dependency",
  SMART_FLOW_EDGE = "smart-flow",
  BACKFLOW_EDGE = "backflow-edge"
}
